import { useQuery } from '@tanstack/react-query'

import { getPaymentMethod } from './api'
import { PAYMENT_METHOD_KEY } from './keys'

export function usePaymentMethod(enabled: boolean) {
  return useQuery({
    queryKey: PAYMENT_METHOD_KEY,
    queryFn: ({ signal }) => getPaymentMethod(signal),
    enabled,
    /* the portal opens in a second tab, so coming back is the signal the card
     * may have changed. the shared 30s staleTime would swallow a quick trip. */
    refetchOnWindowFocus: true,
    staleTime: 0
  })
}
